import { render, staticRenderFns } from "./priceListCreateModal.vue?vue&type=template&id=68ef88cf&"
import script from "./priceListCreateModal.vue?vue&type=script&lang=ts&"
export * from "./priceListCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports